import { configureStore, Reducer } from '@reduxjs/toolkit';

import calendarReducer from './slices/calendarSlice';
import calendarTasksReducer from './slices/calendarTasksSlice';
import drawerReducer from './slices/drawerSlice';
import { getSetterDynamicListItem, IDynamicListState } from './slices/dynamicListSlice';
import gantDraggableReducer from './slices/gantDraggableSlice';
import gantItemsReducer from './slices/gantItemsSlice';
import gantLoaderReducer from './slices/gantLoaderSlice';
import gantScrollReducer from './slices/gantScrollSlice';
import gantReducer from './slices/gantSlice';
import { getSetterListItem, IListItemState } from './slices/listItemSlice';
import { projectTreeReducer } from './slices/projectTreeSlice';
import { routingSliceReducer } from './slices/routingSlice';
import settingReducer from './slices/settingSlice';
import spinnerReducer from './slices/spinnerSlice';
import { getSetterTable, ITableState } from './slices/tableSlice';
import taskBoardDraggableReducer from './slices/taskBoardDraggableSlice';
import taskBoardReducer from './slices/taskBoardSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
    reducer: {
        drawer: drawerReducer,
        gant: gantReducer,
        setting: settingReducer,
        gantItems: gantItemsReducer,
        gantScroll: gantScrollReducer,
        gantLoader: gantLoaderReducer,
        gantDraggable: gantDraggableReducer,
        calendar: calendarReducer,
        calendarTasks: calendarTasksReducer,
        table: getSetterTable('table') as Reducer<ITableState>,
        listItem: getSetterListItem('listItem') as Reducer<IListItemState>,
        dynamicList: getSetterDynamicListItem('dynamicList') as Reducer<IDynamicListState<any>>,
        spinner: spinnerReducer,
        user: userReducer,
        taskBoardDraggable: taskBoardDraggableReducer,
        taskBoard: taskBoardReducer,
        projectTree: projectTreeReducer,
        routing: routingSliceReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type ComponentsDispatch = typeof store.dispatch;
